import InvestCRMWithdrawlForm from './InvestCRMWithdrawlForm';

export default InvestCRMWithdrawlForm;
